export default {

    bind (el, bindings) {

        const path = el.getAttribute('data-url');

        el.onload = function(){
            if (bindings.value) {
                bindings.value('loaded', path);
            }
        };
        el.onerror = function(){
            if (bindings.value) {
                bindings.value('error', path);
            }
            el.src = '/images/404.svg';
        };

        el.src = path;
    },

    update(el, bindings) {

        const path = el.getAttribute('data-url');

        el.onload = function(){
            if (bindings.value) {
                bindings.value('loaded', path);
            }
        };

        el.onerror = function(){
            if (bindings.value) {
                bindings.value('error', path);
            }
            el.src = '/images/404.svg';
        };

        el.src = path;
    },


}
